import { render } from "./DeletedRolesList.vue?vue&type=template&id=70d6c0cc&scoped=true"
import script from "./DeletedRolesList.vue?vue&type=script&lang=js"
export * from "./DeletedRolesList.vue?vue&type=script&lang=js"

import "./DeletedRolesList.vue?vue&type=style&index=0&id=70d6c0cc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d6c0cc"]])

export default __exports__